import React, { useState, useEffect } from 'react';
import {
    Box,
    FormControlLabel,
    Switch,
    Typography,
    Tooltip
} from '@mui/material';

const SystemSettingsToggle = ({ 
    initialValue = false, 
    disabled = false, 
    isAdmin = false,
    onSystemChange = null 
}) => {
    const [isSystemDevice, setIsSystemDevice] = useState(initialValue);

    useEffect(() => {
        // Update the hidden input field whenever the value changes
        const hiddenInput = document.querySelector('input[name="system"]');
        if (hiddenInput) {
            hiddenInput.value = isSystemDevice ? '1' : '0';
            // Dispatch events so any listeners pick up the change
            hiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
            hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Notify parent component of system change
        if (onSystemChange) {
            onSystemChange(isSystemDevice);
        }
    }, [isSystemDevice, onSystemChange]);

    const handleToggleChange = (event) => {
        setIsSystemDevice(event.target.checked);
    };

    // Only show this component to admins
    if (!isAdmin) {
        return null;
    }

    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
                System Settings
            </Typography>
            <Tooltip title="System devices are available to all users and managed centrally">
                <FormControlLabel
                    control={
                        <Switch
                            checked={isSystemDevice}
                            onChange={handleToggleChange}
                            disabled={disabled}
                            color="primary"
                        />
                    }
                    label="System Device"
                />
            </Tooltip>
            <Typography variant="caption" color="textSecondary" display="block">
                {isSystemDevice 
                    ? "This device is a system device available to all users" 
                    : "This device is a regular user device"
                }
            </Typography>
        </Box>
    );
};

export default SystemSettingsToggle;
